/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Icon } from 'bold-ui'
import { FormRenderProps, SwitchField } from 'components/form'
import { TipoAtendimentoSelectField } from 'components/form/field/select/TipoAtendimentoSelectField/TipoAtendimentoSelectField'
import { PopperButton, PopperControls } from 'components/popper'
import { useState } from 'react'
import { metaPath } from 'util/metaPath'

import {
  HistoricoAtendimentoAdvancedFilterFormModel,
  HistoricoAtendimentoFilterFormModel,
} from '../../model/HistoricoAtendimentoModel'
import HistoricoAtendimentoActiveFilters from './HistoricoAtendimentoActiveFilters'
import HistoricoAtendimentoFilterPopper from './HistoricoAtendimentoFilterPopper'
import { HistoricoAtendimentoSortDropdown } from './HistoricoAtendimentoSortDropDown'

const path = metaPath<HistoricoAtendimentoFilterFormModel>()

export interface HistoricoAtendimentoFilterProps extends FormRenderProps<HistoricoAtendimentoFilterFormModel> {}

export default function HistoricoAtendimentoFilter(props: HistoricoAtendimentoFilterProps) {
  const { form, pristine, handleSubmit, values, initialValues } = props
  const [activeAdvancedFilters, setActiveAdvancedFilters] = useState<HistoricoAtendimentoAdvancedFilterFormModel>()

  const onSubmit = (filters: HistoricoAtendimentoAdvancedFilterFormModel) => {
    setActiveAdvancedFilters(filters)
    handleSubmit()
  }

  const onClear = () => {
    form.reset()
    setActiveAdvancedFilters(undefined)
  }

  const renderPopper = ({ close }: PopperControls) => (
    <HistoricoAtendimentoFilterPopper
      path={path.filtrosAvancados}
      advancedFilters={values.filtrosAvancados}
      tipoAtendimento={values.tipoAtendimento}
      isFiltersFormClean={pristine}
      filterInitialValues={initialValues}
      close={close}
      clear={onClear}
      onSubmit={onSubmit}
    />
  )

  return (
    <Grid>
      <Cell size={3}>
        <TipoAtendimentoSelectField name={path.tipoAtendimento} label='Tipo de atendimento' />
      </Cell>
      <Cell
        size={4}
        style={css`
          align-items: flex-end;
          display: inline-flex;
          justify-content: flex-start;
        `}
      >
        <SwitchField name='somenteMeusAtendimentos' label='Ver somente os meus atendimentos' />
      </Cell>
      <Cell
        size={3}
        style={css`
          align-items: flex-end;
          display: inline-flex;
          justify-content: flex-end;
        `}
      >
        <HistoricoAtendimentoSortDropdown path={path} />
      </Cell>
      <Cell
        size={2}
        style={css`
          align-items: flex-end;
          display: inline-flex;
          justify-content: flex-end;
        `}
      >
        <PopperButton kind='primary' size='small' skin='default' placement='bottom-end' renderPopper={renderPopper}>
          <Icon icon='filterOutline' />
          Outros filtros (4)
        </PopperButton>
      </Cell>
      {activeAdvancedFilters && (
        <Cell size={12}>
          <HistoricoAtendimentoActiveFilters filters={activeAdvancedFilters} />
        </Cell>
      )}
    </Grid>
  )
}
